"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = __importDefault(require("../../../index"));
var Button_1 = __importDefault(require("../../../Elements/Button"));
var schema_1 = __importDefault(require("./schema"));
var Formik_1 = __importDefault(require("../../../Elements/Radio/Group/Formik"));
var FormikConditionalField_1 = __importDefault(require("../../../Elements/FormikConditionalField"));
var Formik_2 = __importDefault(require("../../../Elements/Checkbox/Single/Formik"));
var Formik_3 = __importDefault(require("../../../Elements/Time/RangePicker/Formik"));
var Formik_4 = __importDefault(require("../../../Elements/Select/Formik"));
var Formik_5 = __importDefault(require("../../../Elements/TextInput/Formik"));
var FormikCol_1 = __importDefault(require("../../../Elements/FormikCol"));
var FormikRow_1 = __importDefault(require("../../../Elements/FormikRow"));
var CreatePickupSettings = function (_a) {
    var mutation = _a.mutation, mutationVariablesFormatter = _a.mutationVariablesFormatter, _b = _a.initialValues, initialValues = _b === void 0 ? {
        name: "",
    } : _b, onSuccess = _a.onSuccess, projectSelect = _a.projectSelect;
    var PICKUP_METHODS = [
        { label: "Fixed", value: "fixed" },
        { label: "Dynamic", value: "dynamic" },
    ];
    var FIXED_PICKUPS = [
        { label: "Week", value: "week" },
        { label: "Days", value: "days" },
        { label: "Customizable", value: "flexible" },
    ];
    var DAYS = [
        { label: "Monday", value: "monday" },
        { label: "Tuesday", value: "tuesday" },
        { label: "Wednesday", value: "wednesday" },
        { label: "Thursday", value: "thursday" },
        { label: "Friday", value: "friday" },
        { label: "Saturday", value: "saturday" },
        { label: "Sunday", value: "sunday" },
    ];
    return (react_1.default.createElement(index_1.default, { mutation: mutation, mutationVariablesFormatter: mutationVariablesFormatter, onSuccess: onSuccess, formikProps: {
            initialValues: initialValues,
            validationSchema: schema_1.default,
            onSubmit: function () { return console.log("not-used"); },
        } }, function (_a) {
        var isSubmitting = _a.isSubmitting, submitForm = _a.submitForm;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            projectSelect,
            react_1.default.createElement(Formik_5.default, { antd: {
                    label: "Name",
                    required: true,
                    labelCol: { span: 24, offset: 0 },
                }, name: "name" }),
            react_1.default.createElement(Formik_1.default, { antd: {
                    label: "Pickup method",
                    required: true,
                    labelCol: { span: 24, offset: 0 },
                }, options: PICKUP_METHODS, optionType: "button", name: "pickupMethod", buttonStyle: "solid" }),
            react_1.default.createElement(FormikConditionalField_1.default, { shouldShow: function (values) { return values.pickupMethod === "fixed"; } },
                react_1.default.createElement(Formik_1.default, { antd: {
                        label: "Collection interval",
                        labelCol: { span: 24, offset: 0 },
                    }, options: FIXED_PICKUPS, optionType: "button", name: "fixedPickupsPeriod", buttonStyle: "solid" }),
                react_1.default.createElement(FormikConditionalField_1.default, { shouldShow: function (values) {
                        return values.fixedPickupsPeriod === "week";
                    } },
                    react_1.default.createElement(Formik_4.default, { options: Array.from(Array(7).keys()).map(function (d) { return ({
                            value: d + 1,
                            label: d + 1,
                        }); }), name: "collectionPerWeek", antd: {
                            label: "Collections per week",
                            labelCol: { span: 24, offset: 0 },
                        } }),
                    react_1.default.createElement(Formik_4.default, { options: Array.from(Array(52).keys()).map(function (d) { return ({
                            value: d + 1,
                            label: d + 1,
                        }); }), name: "pickupRepeatPeriod", antd: {
                            label: "Weeks between",
                            labelCol: { span: 24, offset: 0 },
                        } }),
                    DAYS.map(function (_a) {
                        var label = _a.label, value = _a.value;
                        return (react_1.default.createElement(FormikCol_1.default, null,
                            react_1.default.createElement(FormikRow_1.default, { span: 12 },
                                react_1.default.createElement(Formik_2.default, { name: "pickupDay." + value + ".collect", antd: {
                                        label: "",
                                    }, description: label })),
                            react_1.default.createElement(FormikRow_1.default, { span: 12 },
                                react_1.default.createElement(Formik_3.default, { antd: {
                                        label: "",
                                    }, name: "pickupDay." + value + ".time" }))));
                    })),
                react_1.default.createElement(FormikConditionalField_1.default, { shouldShow: function (values) {
                        return values.fixedPickupsPeriod === "days";
                    } },
                    react_1.default.createElement("p", null, "days")),
                react_1.default.createElement(FormikConditionalField_1.default, { shouldShow: function (values) {
                        return values.fixedPickupsPeriod === "flexible";
                    } },
                    react_1.default.createElement("p", null, "flexible"))),
            react_1.default.createElement(Button_1.default, { type: "primary", disabled: isSubmitting, title: "Save", onClick: submitForm })));
    }));
};
exports.default = CreatePickupSettings;
